import { Injectable } from '@angular/core';
import {
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { NbAuthService } from '@nebular/auth';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivateChild {
  constructor(private authService: NbAuthService, private router: Router) {
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // console.log("this.authService", this.authService);

    // return true;

    return this.authService.isAuthenticated().pipe(
      switchMap((value) => {
        // return of(true);
        return value ? of(true) : of(this.router.parseUrl('auth/login'));
      })
    )
  }
}
